"use client";

import { Input } from "@/components/ui/input";
import { IBlocks } from "@/types";
import React from "react";
import CardSetting from "@/components/admin/settings/CardSetting";
interface Props {
    block: IBlocks;
    blockUpdate: React.Dispatch<React.SetStateAction<IBlocks>>;
    update: (value: IBlocks) => void;
}
export default function LinkCopyOptions({ block, blockUpdate, update }: Props) {
    const [oldBlock, setOldBlock] = React.useState(block);
    const [name, setName] = React.useState(block.name);
    const [url, setUrl] = React.useState(block.url);
    return (
        <div className="flex w-full flex-col gap-3">
            <CardSetting title="General" noBorder>
                <div className="flex w-full flex-col gap-3">
                    <Input
                        label="Title"
                        placeholder="Click me"
                        variant="card"
                        className="w-full"
                        required
                        value={name}
                        onChange={(e) => {
                            setName(e.target.value);
                            blockUpdate({
                                ...block,
                                name: e.target.value,
                            });
                        }}
                        onBlur={(e) => {
                            if (oldBlock.name != e.target.value) {
                                update({
                                    ...block,
                                    name: e.target.value,
                                });
                                setOldBlock({
                                    ...oldBlock,
                                    name: e.target.value,
                                });
                            }
                        }}
                    />
                    <Input
                        label="Clipboard text"
                        variant="card"
                        className="w-full"
                        placeholder="Some random text"
                        required
                        value={url}
                        onChange={(e) => {
                            setUrl(e.target.value);
                            blockUpdate({
                                ...block,
                                url: e.target.value,
                            });
                        }}
                        onBlur={(e) => {
                            if (oldBlock.url != e.target.value) {
                                update({
                                    ...block,
                                    url: e.target.value,
                                });
                                setOldBlock({
                                    ...oldBlock,
                                    url: e.target.value,
                                });
                            }
                        }}
                    />
                </div>
            </CardSetting>
        </div>
    );
}
